export type TrackedPolitician = {
  slug: string
  name: string
  initials: string
  office: string
  party: string
  state: string
  status: 'arquivo-ativo' | 'em-preparacao'
  summary: string
  route: string
}

export const politicians: TrackedPolitician[] = [
  { slug: 'jair-bolsonaro', name: 'Jair Bolsonaro', initials: 'JB', office: 'Ex-presidente da República', party: 'PL', state: 'Brasil', status: 'arquivo-ativo', summary: 'Pandemia, ciência, violência, dinheiro, religião e a condenação pelo golpe: registros confrontados com contexto, defesa e desfecho.', route: '/jair-bolsonaro' },
  {
    slug: 'flavio-bolsonaro',
    name: 'Flávio Bolsonaro',
    initials: 'FB',
    office: 'Senador',
    party: 'PL',
    state: 'RJ',
    status: 'arquivo-ativo',
    summary: 'Dinheiro, relações, mudanças de versão, propostas de governo e declarações confrontadas com documentos e fontes abertas.',
    route: '/flavio-bolsonaro',
  },
]
